var exports = {
  "container": "x43cbe9c2--f3e70c--container",
  "text-block": "x43cbe9c2--f3e70c--text-block",
  "title": "x43cbe9c2--f3e70c--title",
  "description": "x43cbe9c2--f3e70c--description",
  "btn": "x43cbe9c2--f3e70c--btn",
  "phone": "x43cbe9c2--f3e70c--phone",
};

module.exports = exports;
